import { api, getToken } from "./helpers";

// A different task may own the first collection. Retry only its explicit pending
// response, never an error or a write, and never force another catalog refresh.
export async function readContentCounts(instanceId, { signal } = {}) {
  const session = getToken?.();
  const current = () => !signal?.aborted && getToken?.() === session;
  for (let attempt = 0; attempt < 4 && current(); attempt++) {
    const result = await api(`/api/instances/${encodeURIComponent(instanceId)}/content-counts`, { signal, retry: false });
    if (!current()) return null;
    if (!result?.loading) return result;
    if (attempt === 3) return null;
    await new Promise(resolve => {
      let timer;
      const finish = () => { clearTimeout(timer); signal?.removeEventListener("abort", finish); resolve(); };
      timer = setTimeout(finish, [2000, 5000, 10000][attempt]);
      signal?.addEventListener("abort", finish, { once: true });
      if (!current()) finish();
    });
  }
  return null;
}
